import React from "react";

export const Tag = ({ title, background, color }): JSX.Element => {
  return (
    <div className={`h-6 ${background} px-3 py-1 rounded-3xl`}>
      <p className={`text-xs font-normal ${color}`}>{title}</p>
    </div>
  );
};
